document.addEventListener('DOMContentLoaded', function() {
    var videoContainers = document.querySelectorAll('.video-container');

    videoContainers.forEach(function(container) {
        var videoId = container.getAttribute('data-video-id');
        var video = document.getElementById('video-' + videoId);
        var playButton = container.querySelector('.video-play');
        var progressBar = container.querySelector('.video-progressBar');
        var seekBar = container.querySelector('.video-seek');
        var forwardButton = container.querySelector('.video-forward');
        var fullscreenButton = container.querySelector('.video-fullscreen');
        var muteButton = container.querySelector('.video-muted');

        // 初期状態の変数
        var isPlaying = !video.paused;
        var isMuted = video.muted;

        // 初期状態のアイコン設定
        playButton.querySelector('img[alt="play video"]').style.display = 'block';
        playButton.querySelector('img[alt="pause video"]').style.display = 'none';

        // 自動再生後にアイコンを一時停止に変更
        video.addEventListener('play', function() {
            playButton.querySelector('img[alt="play video"]').style.display = 'none';
            playButton.querySelector('img[alt="pause video"]').style.display = 'block';
        });

        video.addEventListener('pause', function() {
            playButton.querySelector('img[alt="play video"]').style.display = 'block';
            playButton.querySelector('img[alt="pause video"]').style.display = 'none';
        });

        // Play/Pause functionality
        playButton.addEventListener('click', function() {
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
        });

        // Update progress bar and seek bar
        video.addEventListener('timeupdate', function() {
            if (isFinite(video.duration) && isFinite(video.currentTime)) {
                var value = (video.currentTime / video.duration) * 100;
                progressBar.value = value;
                seekBar.value = video.currentTime;
            }
        });

        // Set seek bar max value once metadata is loaded
        video.addEventListener('loadedmetadata', function() {
            if (isFinite(video.duration)) {
                seekBar.max = video.duration;
                progressBar.max = 100;
            }
        });

        // Seek functionality
        seekBar.addEventListener('input', function() {
            if (isFinite(video.duration)) {
                video.currentTime = seekBar.value;
            }
        });

        // Forward functionality
        forwardButton.addEventListener('click', function() {
            video.currentTime += 10;
        });

        // Fullscreen functionality
        fullscreenButton.addEventListener('click', function() {
            if (video.requestFullscreen) {
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                } else {
                    video.requestFullscreen();
                }
            } else if (video.webkitEnterFullScreen) { // iOS Safari
                video.webkitEnterFullScreen();
            } else if (video.mozRequestFullScreen) {
                if (document.mozFullScreenElement) {
                    document.mozCancelFullScreen();
                } else {
                    video.mozRequestFullScreen();
                }
            } else if (video.msRequestFullscreen) {
                if (document.msFullscreenElement) {
                    document.msExitFullscreen();
                } else {
                    video.msRequestFullscreen();
                }
            }
        });

        // Mute/Unmute functionality
        muteButton.addEventListener('click', function() {
            video.muted = !video.muted;
            isMuted = video.muted;

            if (isMuted) {
                muteButton.querySelector('img[alt="soundoff video"]').style.display = 'block';
                muteButton.querySelector('img[alt="soundon video"]').style.display = 'none';
            } else {
                muteButton.querySelector('img[alt="soundoff video"]').style.display = 'none';
                muteButton.querySelector('img[alt="soundon video"]').style.display = 'block';
            }
        });
    });
});
